module.exports = __webpack_public_path__ + "img/浙江学校bg.50a32c63.png";